import React from 'react';

type EvaEntryExperimentGateProps = {
  children: React.ReactNode;
};

/**
 * In Eva Search V2, both control and variant receive the conversational
 * Eva Search experience. The ElevenLabs widget is no longer loaded.
 * This gate now simply renders its children.
 */
export default function EvaEntryExperimentGate({
  children,
}: EvaEntryExperimentGateProps): JSX.Element {
  return <>{children}</>;
}
